// Marca de "já consultou os avisos pendentes nesta sessão". Sem imports de
// propósito: é usado pelo store (logout) e não pode puxar a cadeia store -> http.
// O valor guardado é o token da sessão: login ou troca de conta geram token novo
// e portanto voltam a consultar.
export const ANNOUNCEMENTS_CHECKED_KEY = "cliente.announcements.checked";

export function wasAnnouncementsChecked(token) {
    try {
        return (
            !!token &&
            window.sessionStorage.getItem(ANNOUNCEMENTS_CHECKED_KEY) === token
        );
    } catch (e) {
        return false;
    }
}

export function markAnnouncementsChecked(token) {
    try {
        if (token) window.sessionStorage.setItem(ANNOUNCEMENTS_CHECKED_KEY, token);
    } catch (e) {
        // sessionStorage indisponível: só volta a consultar no próximo carregamento.
    }
}

/** Limpa a marca (logout / sessão expirada). */
export function clearAnnouncementsSession() {
    try {
        window.sessionStorage.removeItem(ANNOUNCEMENTS_CHECKED_KEY);
        // Chaves antigas por usuário (cliente.announcements.checked.<id>).
        Object.keys(window.sessionStorage)
            .filter((key) => key.startsWith(ANNOUNCEMENTS_CHECKED_KEY + "."))
            .forEach((key) => window.sessionStorage.removeItem(key));
    } catch (e) {
        // sessionStorage indisponível: nada a limpar.
    }
}
